var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg10(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#FF0064",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#00FFC2",
    points: "15.99249 22.89827 10.99249 17.89827 5.99249 22.89827 10.99249 27.89827"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#00FFC2",
    points: "26.00752 22.89827 21.00752 17.89827 16.00752 22.89827 21.00752 27.89827"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#00FFC2",
    points: "15.99249 12.88324 10.99249 7.88324 5.99249 12.88324 10.99249 17.88324"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#00FFC2",
    points: "26.00752 12.88324 21.00752 7.88324 16.00752 12.88324 21.00752 17.88324"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-62",
    fill: "#00FFC2",
    points: "20.99811 31.11676 15.99811 26.11676 10.99811 31.11676 15.99811 36.11676"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10);
export default __webpack_public_path__ + "static/media/10.f32a37797abf9aa48f58aedcb93423d8.svg";
export { ForwardRef as ReactComponent };